import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateUxpTransferBatchMutationVariables = Types.Exact<{
  input: Types.UpdateTransferBatchInput;
}>;


export type UpdateUxpTransferBatchMutation = { __typename?: 'Mutation', updateTransferBatch?: { __typename?: 'UpdateTransferBatchPayload', transferBatch: { __typename?: 'TransferBatch', id: string } } | null };


export const UpdateUxpTransferBatch = /*#__PURE__*/ gql`
    mutation UpdateUxpTransferBatch($input: UpdateTransferBatchInput!) {
  updateTransferBatch(input: $input) {
    transferBatch {
      id
    }
  }
}
    ` as unknown as DocumentNode<UpdateUxpTransferBatchMutation, UpdateUxpTransferBatchMutationVariables>;

          

          export const useUpdateUxpTransferBatchMutation = (options?:MutationHookOptions<UpdateUxpTransferBatchMutation, UpdateUxpTransferBatchMutationVariables>) => useMutation(UpdateUxpTransferBatch, options);
          

          export type UpdateUxpTransferBatchMutationOptions = MutationHookOptions<UpdateUxpTransferBatchMutation, UpdateUxpTransferBatchMutationVariables>;

          

          export type UpdateUxpTransferBatchMutationResult = ReturnType<typeof useUpdateUxpTransferBatchMutation>[1];

          
